(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["couture-enquiry"] && !Shopify.designMode) return;
  try {
    
  function keepCoutureEnquiryClear() {
    if (!document.querySelector('.couture-enquiry')) return;
    document.querySelectorAll('[role="dialog"]').forEach((dialog) => {
      if (!dialog.querySelector('form[data-testid="klaviyo-form-QVPgAr"]')) return;
      dialog.querySelector('button.klaviyo-close-form')?.click();
    });
  }
  window.addEventListener('klaviyoForms', (event) => {
    if (event.detail?.type === 'open') requestAnimationFrame(keepCoutureEnquiryClear);
  });
  keepCoutureEnquiryClear();
  function initialiseCoutureForms() {
    document.querySelectorAll('.couture-enquiry__form').forEach((form) => {
      if (form.dataset.coutureReady) return;
      form.dataset.coutureReady = 'true';
      const type = form.querySelector('[data-enquiry-type]');
      if (!type) return;
      const update = () => {
        form.querySelectorAll('[data-couture-field]').forEach((field) => {
          const enabled = type.value === 'Couture' || type.value === 'Custom order';
          field.hidden = !enabled;
          field.querySelectorAll('input, select').forEach((input) => {
            input.disabled = !enabled;
            input.required = enabled && input.hasAttribute('data-couture-required');
          });
        });
        form.querySelectorAll('[data-order-field]').forEach((field) => {
          const enabled = type.value === 'Existing order';
          field.hidden = !enabled;
          field.querySelector('input').disabled = !enabled;
        });
      };
      type.addEventListener('change', update);
      update();
    });
  }
  const appointmentLayoutMedia = window.matchMedia('(min-width: 901px)');
  function orderAppointmentInformation() {
    document.querySelectorAll('.couture-enquiry--appointment.couture-enquiry--editorial .couture-enquiry__columns').forEach((columns) => {
      const information = columns.querySelector('.couture-enquiry__appointment-info');
      const form = columns.querySelector('.couture-enquiry__form-wrap');
      if (!information || !form) return;
      if (appointmentLayoutMedia.matches) {
        if (information.nextElementSibling !== form) columns.insertBefore(information, form);
      } else if (columns.lastElementChild !== information) {
        columns.append(information);
      }
    });
  }
  appointmentLayoutMedia.addEventListener('change', orderAppointmentInformation);
  document.addEventListener('DOMContentLoaded', orderAppointmentInformation);
  document.addEventListener('shopify:section:load', orderAppointmentInformation);
  orderAppointmentInformation();
  initialiseCoutureForms();
  if (document.querySelector('.couture-enquiry')) {
    const popupWatcher = new MutationObserver(keepCoutureEnquiryClear);
    popupWatcher.observe(document.body, {childList: true, subtree: true});
  }
  document.addEventListener('DOMContentLoaded', initialiseCoutureForms);
  document.addEventListener('shopify:section:load', initialiseCoutureForms);

  } catch(e) { console.error(e); }
})();
})();
